import React from 'react';

/** Contacto / CTA final — versión breve (sin formulario largo ni doble banda). */
export const CTASection: React.FC = () => {
  return (
    <section id="contacto" className="py-16 bg-gradient-to-br from-[#0B1F4A] to-[#1A56DB] text-white scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl sm:text-3xl font-bold mb-3">¿Empezamos?</h2>
        <p className="text-white/90 mb-8 text-lg">Crea tu cuenta gratis o entra con la tuya.</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/registro"
            className="inline-flex justify-center items-center bg-white text-[#0B1F4A] px-8 py-3 rounded-xl font-semibold hover:bg-gray-100 transition-colors"
          >
            Crear cuenta
          </a>
          <a
            href="/login"
            className="inline-flex justify-center items-center border-2 border-white/90 text-white px-8 py-3 rounded-xl font-semibold hover:bg-white/10 transition-colors"
          >
            Iniciar sesión
          </a>
        </div>
        <p className="mt-10 text-sm text-white/70">
          ¿Necesitas ayuda?{' '}
          <a href="/soporte" className="underline hover:text-white">
            Solicitar ayuda
          </a>
        </p>
      </div>
    </section>
  );
};
